export const locale = {
  lang: 'es-ES',
  data: {
    MENU: {
      TOOLBAR: {
        SIGN_UP: 'Iniciar Sesión',
        REGISTER: 'Registrarse',
        LOGOUT: 'Cerrar Sesión',
        HOME: 'Inicio',
        SOLUTION: 'Soluciones',
        OBJETIVE: 'Objetivo',
        PROJECTS: 'Proyectos',
        CONTACT: 'Contáctanos',
        ALT: 'Logo de Incroco',
        TITLE: 'Incroco',
        COPYRIGHT: 'Copyright © ',
      },
    },
    STATUS: {
      NEW: 'Nuevo',
      FUNDING: 'En financiamiento',
      DEVELOPMENT: 'En Desarrollo',
      ONGOING: 'En curso',
      FINISHED: 'Finalizado',
    },
    CHANGE_PASSWORD: {
      HAS_MIN_LENGTH: 'Mínimo 8 caracteres',
      HAS_UPPERCASE: 'Al menos una mayúscula',
      HAS_NUMBER: 'Al menos 1 número',
      HAS_SPECIAL_CHARACTER: 'Al menos un signo ( ¿ ¡ ! ? % _ - @ # $ * & )',
      IS_MATCH: 'Las contraseñas deben coincidir',
    },
    AUTH: {
      TERMS: 'Términos y condiciones',
      PRIVACY_POLITICS: 'Políticas de privacidad',
      ACTIVE_ACCOUNT: {
        TITLE: '¡Felicidades! Tu cuenta se ha creado con éxito',
        TEXT: 'Tu cuenta en nuestro sistema aún no ha sido activada. Para poder acceder a todos los servicios que ofrecemos, es necesario que actives tu cuenta ingresando al correo electrónico que utilizaste para registrarte.',
        BUTTON: 'Reenviar correo de activación',
      },
      CHANGE_PASSWORD: {
        TITLE: 'Cambiar Contraseña',
        INPUT: {
          NEW_PASSWORD: 'Nueva Contraseña',
          REPEAT_PASSWORD: 'Repetir Contraseña',
        },
        BUTTON: 'Cambiar Contraseña',
      },
      LOGIN: {
        TITLE: 'Iniciar Sesión',
        INPUT: {
          EMAIL: 'Correo Electrónico',
          PASSWORD: 'Contraseña',
        },
        FORGOT_PASSWORD: '¿Olvidaste tu usuario o contraseña?',
        REGISTER: 'Registrarse',
        SUCCESS: 'Tu contraseña se </br> modificó correctamente'
      },
      REGISTER: {
        TITLE: 'Registro',
        SUBTITLE:
          'Ingresa tu correo electrónico para enviarte un código de verificación.',
        INPUT: {
          EMAIL: 'Correo Electrónico',
        },
        CREATE_ACCOUNT: 'Crear Cuenta',
        SIGN_UP: 'Iniciar Sesión',
        ACCEPT: 'Acepto los',
        AND_THE: 'y las',
      },
      REGISTER_CREATE_PASSWORD: {
        TITLE: 'Crear Contraseña',
        INPUT: {
          NEW_PASSWORD: 'Nueva Contraseña',
          REPEAT_PASSWORD: 'Repetir Contraseña',
        },
        CONFIRM: 'Confirmar',
      },
      VALIDATE_CODE: {
        TITLE: 'Valida tu correo electrónico',
        SUBTITLE: 'Introduzca el código enviado a:',
        INPUT: {
          CODE: 'Código',
        },
        BUTTON: 'Validar correo',
      },
      RESET_PASSWORD: {
        TITLE: 'Recuperar Cuenta',
        SUBTITLE: 'Ingresa tu correo para recuperar tu cuenta',
        INPUT: {
          EMAIL: 'Correo Electrónico',
        },
        BUTTON: 'Recuperar Cuenta',
      },
      RESET_PASSWORD_SUCCESS: {
        TITLE: 'Recuperar Contraseña',
        SUBTITLE: 'Te hemos enviado un correo con los pasos a seguir para actualizar tu contraseña',
      },
      REGISTER_DATA: {
        TITLE: 'Información de la Cuenta',
        TITLE_CODE: 'Código de Referido',
        INPUT: {
          NAME: 'Nombre',
          LAST_NAME: 'Apellido',
          BIRTH: 'Fecha de Nacimiento',
          PHONENUMBER: 'Número de teléfono',
          GENDER: {
            TITLE: 'Género',
            M: 'Masculino',
            F: 'Femenino',
          },
          NATIONALITY: 'Nacionalidad',
          EP: 'Soy una persona póliticamente expuesta',
          UIF: 'Soy un sujeto obligado ante la UIF',
          PHONE_AREA: 'Cod. área',
          PHONE_NUMBER: 'Teléfono',
          REFERRAL: 'Referido',
        },
        BUTTON: 'Crear Cuenta',
      },
    },
    PUBLIC: {
      LANDING: {},
      CROWDFUNDING: {},
    },
    CROWDFUNDING: {
      DETAIL: {
        INVEST: 'Invertir',
        CONTACT: 'Contacto',
        CALCULATOR: 'Calculadora',
        SHARE: 'Compartir',
        LOCATION: 'Ubicación',
        TYPE: 'Tipo de Propiedad',
        PERIOD: 'Período',
        RENTABILITY: 'Rentabilidad Estimada',
        MIN_INVEST: 'Inversión Mínima',
        TOKEN: 'Token',
        DESCRIPTION: 'Descripción de la Propiedad',
        PROGRESS: 'Progreso',
        FEATURES: 'Características',
        NEWS: 'Noticias',
        SEE_NEWS: 'Ver Noticias',
      },
      CHECKOUT: {
        TITLE: 'Proceso de Compra',
        ARS: 'Saldo en PESOS',
        USD: 'Saldo en Dólares',
        QUANTITY: 'Cantidad de Tokens',
        TOKEN: 'Valor del Token',
        SUCCESS: {
          TITLE: 'Tu compra fue exitosa',
          SUBTITLE: 'Puedes seguir tu inversión ingresando a tu Portafolio',
          BUTTON: 'Ir al Portafolio',
        },
        SUMMARY: {
          TITLE: 'Agrega el dinero que quieres invertir',
          SUBTITLE: 'Debes contar con el saldo necesario para poder invertir',
          INPUT: {
            MONEY: 'Ingresa la cantidad que deseas invertir',
          },
          ERROR: {
            INSUFFICIENT_FUNDS:
              'No tienes suficiente dinero para realizar la operación',
            NEGATIVE_NUMBERS: 'No se permiten números negativos.',
          },
          QUANTITY: 'Cantidad de Tokens a Comprar',
          SUBTOTAL: 'Subtotal',
          COMMISION: 'Comisión',
          PRICE: 'Precio del Token',
          TOTAL: 'Total',
          ACCEPT: 'Acepto los',
          RISK: 'y soy consciente de los riesgos',
          INVEST: 'Invertir',
          DISCLAIMER: 'Descargo de responsabilidad',
          DISCLAIMER_TITLE: 'Estás comprando una cuotaparte de un fideicomiso.',
          CONFIRM_INVEST: 'Confirmar Inversión',
          CONFIRM: 'Confirmar Compra',
          CONFIRM_TEXT:
            'Agradecemos tu participación en nuestra inversión inmobiliaria. Queremos recordarte que, <span>una vez comprometido con un proyecto, es fundamental respetar el tiempo acordado para maximizar los beneficios. <br /> Si decides retirarte antes del plazo determinado, se aplicará una penalidad y no recibirás la totalidad de tus ganancias.</span>',
        },
      },
      LIST: {
        TITLE: 'Descubre el mundo <br /><span>de la construcción</span>',
        SUBTITLE:
          'Te ofrecemos la oportunidad de ser parte de nuestras ganancias como nuestro socio. Únete a nosotros y juntos hagamos realidad tus sueños de construcción con un equipo de expertos y una colaboración mutua rentable, <span>incrementando los márgenes al eliminar intermediarios</span>',
        FILTERS: 'Filtros',
        TYPE_PROJECTS: 'Tipo de Proyecto',
        PERCENTAGE: 'Porcentaje de Avance',
        RENTABILITY: 'Rentabilidad Anual',
        DURATION: 'Duración del Proyecto',
        ORDER_BY: 'Ordenar Por',
      },
    },

    PLATFORM: {
      MENU: {
        DASHBOARD: 'Dashboard',
        PORTFOLIO: 'Portafolio',
        MOVEMENTS: 'Movimientos',
        TRADING: 'Trading',
        DEPOSIT: 'Depósito',
        REFERRAL: 'Referido',
        PROJECTS: 'Proyectos',
        PROFILE: 'Mi Perfil',
        LOGOUT: 'Cerrar Sesión', 
      },
      OPPORTUNITIES: {
        TITLE: 'Oportunidades',
        TOKEN: 'Token',
        VALUE: 'Valores',
      },
      DASHBOARD: {
        ALERT: {
          VALIDATE_BTN: 'Validar Identidad',
          VALIDATE_MSG: 'Valida tu identidad para comenzar a participar',
        },
        DATA: {
          PROJECTS: 'Proyectos en Incroco',
          PROJECTS_IN: 'Proyectos Participante',
          ACCUMULATED: 'Ganancia acumulada',
          PROJECTED: 'Ganancias proyectadas',
          INVEST: 'Saldo invertido',
        },
        ACCOUNT: {
          TITLE: 'Saldo Disponible',
          ADD_FUNDS: 'Agregar Fondos',
          CASHOUT: 'Retirar Dinero',
        },
        VALIDATE: {
          TITLE: 'Validación perfil',
          GO_TO_PROFILE: 'IR AL PERFIL',
          EMAIL: 'Mail',
          AF: 'Identidad',
          PHONE: 'Teléfono',
          DDJJ: 'DDJJ',
          ADDRESS: 'Dirección',
        },
      },
      MOVEMENTS: {
        TITLE: 'Mis Movimientos',
        ALL_PROJECTS: 'Todos los proyectos',
        ALL_MOVEMENTS: 'Todos los movimientos',
        OK: 'Ejecutada',
        PENDING: 'Pendiente',
        CANCELLED: 'Cancelada',
        INVERT: 'Inversiones',
        WITHDRAW: 'Extracción',
        DEPOSIT: 'Depósito',
        BUY: 'Compra',
        SELL: 'Ventas',
        X: 'Bonus',
        TRANSFER: 'Transferencia',
        REFEER: 'Referido',
        LIST: {
          DATE: 'Fecha',
          DESCRIPTION: 'Descripción',
          AMOUNT: 'Monto',
          Q_TOKEN: 'C. Token',
          OPERATION: 'Operación',
          STATUS: 'Estado',
          CANCEL_ORDER: 'Cancelar Orden',
          SEE_INVOICE: 'Ver Comprobante',
          COMMISION: 'Comisión',
          TOTAL: 'Total',
          EMPTY: 'Todavía no seleccionaste <br />ninguna operación',
        },
        SEE_PROJECTS: 'Ver proyectos',
        SEE_PROJECT: 'Ver detalles',
        WITHOUT_MOVEMENTS: 'Todavía no realizaste ningún movimiento',
      },
      PORTFOLIO: {
        TITLE: 'Portfolio',
        ARS: 'Saldo cuenta PESOS',
        USD: 'Saldo cuenta Dólares',
        LIST: {
          PROJECT: 'Proyecto',
          PERCENTAGE: 'Porcentaje del proyecto',
          RETURN: 'Ganancia',
          STATUS: 'Estado',
          FINISH: 'Finalizado',
          REVENUE: 'Retorno',
          MOVEMENTS: 'Mis Movimientos',
          DELETE_ORDER: 'Borrar Orden',
          INVERT: 'Invertido',
        },
        EMPTY_BTN: 'Ver proyectos',
        EMPTY_MSG: 'Todavía no sos parte de ningún proyecto',
      },
      PROFILE: {
        TABS: {
          PERSONAL_DATA: 'Datos Personales',
          BANK: 'Cuentas Bancarias',
          DOCUMENTS: 'Documentos',
          CHANGE_PASSWORD: 'Cambiar Contraseña',
        },
        BANK: {
          CARD: {
            TITLE: 'CUENTAS BANCARIAS PARA DEPOSITAR',
            TITULAR: 'Titular',
            CUIT: 'CUIL/CUIT',
            USD: 'Incroco Dólares',
            ARS: 'Incroco Pesos',
            DELETE: 'Borrar',
            CBU: 'CBU',
            BANK: 'Banco',
            CURRENCY: 'Moneda',
            ALIAS: 'Alias',
          },
          ACCOUNT: 'Cuenta Incroco',
          BTN_ACCOUNT: 'Agregar Cuenta',
          ADD_ACCOUNT: {
            TITLE: 'Agregar cuenta bancaria',
            SUBTITLE: 'Solo se pueden cargar cuentas de las que seas titular',
            ADD: 'Agregar Cuenta',
            CANCEL: 'Cancelar',
            CURRENCY: 'Moneda',
            INPUT: {
              ALIAS: 'CBU/Alias',
              ADD_CBU: 'Agregar CBU',
              NICKNAME_ACCOUNT: 'Sobrenombre de la cuenta',
              ERROR_REQUIRED: 'Este Campo es requerido',
              MIN_CBU: 'Tiene que tener un mínimo de 22 caracteres',
              MIN_NICKNAME: 'Tiene que tener un mínimo de 3 caracteres',
              MAX_NICKNAME: 'Tiene que tener un máximo de 50 caracteres',
            },
          },
          EMPTY_MSG: 'Todavía no tenes ninguna cuenta bancaria',
          EMPTY_BTN: '+ Agrega tu cuenta',
        },
        CHANGE_PASSWORD: {
          OLD_PASSWORD: 'Contraseña Anterior',
          NEW_PASSWORD: 'Nueva Contraseña',
          REPEAT_PASSWORD: 'Repetir Contraseña',
        },
        DOCUMENTS: {
          TITLE: 'Valida tu identidad',
          EXPLAIN:
            'Para validar tu identidad, envía una foto de tu documento de identidad con frente y dorso visibles, junto con una selfie clara de tu rostro. Esto nos permitirá confirmar tu identidad.',
          DOCUMENT_FRONT: 'Documento Frente',
          DOCUMENT_BACK: 'Documento Dorso',
          GOOD_IMAGES:
            'Imágenes claras y legibles son importantes para procesar su solicitud eficientemente.',
          SELFIE: 'Selfie',
          SELFIE_IMAGE:
            'Necesitamos una foto selfie para compararla con la imagen de su documento de identidad y confirmar que coincide con su apariencia actual.',
          NEXT: 'Siguiente',
          PREVIOUS: 'Volver',
          UPDATE_IMAGE: 'Subi la imagen del',
          DDJJ: 'Declaración Jurada',
          SIGN_DDJJ: 'Firmar Declaración Jurada',
          SUCCESS: '¡Gracias por confiar en nosotros!',
          SUCCESS_TEXT:
            'Revisaremos las imágenes y validaremos su identidad en pocos días hábiles.',
          pending: 'Documentación pendiente de aprobación',
          approved: 'Documentación Aprobada',
          rejected: 'Tu Documentación fue rechazada',
          P_rejected: 'No hemos podido validar de tu identidad por la siguiente razón:</br><b> {{ rejectReason }} </b></br> Puedes cargar nuevamente la documentación.',
          P_pending: 'Tu documentación esta en proceso de revisión por nuestros representantes. Te informaremos por mail cuando hayamos validado tu identidad.'
        },
        PERSONAL_DATA: {
          INPUT: {
            DOCUMENT: 'Documento',
            GENDER: 'Género',
            NAME: 'Nombre',
            LASTNAME: 'Apellido',
            NATIONALITY: 'Nacionalidad',
            DATE: 'Fecha',
            PHONE: 'Teléfono',
            FLOOR: 'Piso',
            CHANGE_NUMBER: 'Cambiar Teléfono',
            VALIDATE_PHONE: 'Validar teléfono',
            INVOICE_ADDRESS: 'Dirección de facturación',
            ADDRESS: 'Dirección',
            APPARTMENT: 'Dpto',
            NUMBER: 'Altura',
            COUNTRY: 'País',
            STATE: 'Provincia',
            LOCALITY: 'Localidad',
            POSTAL_CODE: 'Código Postal',
            ADDITIONAL_INFO: 'Información Adicional',
            SAVE: 'Guardar Dirección',
            EDIT: 'Editar Dirección'
          },
        },
      },
      REFEER: {
        TITLE: 'Referidos',
        TEXT: '¡Descubre una nueva forma de compartir y ganar con nuestra increíble aplicación! Estamos emocionados de presentarte nuestro programa de referidos, donde tú y tus amigos pueden disfrutar de beneficios exclusivos mientras ayudan a hacer crecer nuestra comunidad.',
        TEXT_SPAN: 'Comparte el link a tus amigos.',
        SHARE: 'Compartir',
      },
      TRADING: {
        TITLE: 'Trading',
        LIST: {
          PROJECT: 'Proyecto',
          LAST_PRICE: 'Últ. Precio',
          DAILY_PERCENTAGE: '% Diario',
          SELL: 'Venta',
          BUY: 'Compra',
          AVAILABLE_MONEY: 'Saldo Disponible',
          AVAILABLE_SELL: 'TOKENS DISPONIBLES PARA LA VENTA',
          Q_TOKEN_SELL: 'C. Token Venta',
          PRICE_SELL: 'Precio Venta',
          Q_TOKEN_BUY: 'C. Token Compra',
          PRICE_BUY: 'Precio compra',
          SUBTOTAL: 'Subtotal',
          COMMISION: 'Comisiones',
          CREATE_ORDER_BUY: 'Crear orden de Compra',
          CREATE_ORDER_SELL: 'Crear orden de Venta',
          SEE_PUNTAS: 'Ver Libro de Órdenes',
          TOTAL: 'Total a recibir',
        },
        PUNTAS: {
          TITLE: 'Libro de Órdenes',
          TEXT: 'Listado de libro de órdenes de compra y venta pendientes del proyecto <br> <b>{{ proyectName }}</b>. <br /> <br />Te mostramos en tiempo real las mejores ofertas de compra y venta',
          Q_BUY: 'Cantidad Compra',
          PRICE_BUY: 'Precio Compra',
          Q_SELL: 'Cantidad Venta',
          PRICE_SELL: 'Precio Venta',
        },
        CREATE_ORDER: {
          TITLE: 'Orden de VENTA',
          TEXT: '¡Orden de venta creada con éxito! ¡Gracias por tu compra! <br /> Pronto recibirás actualizaciones sobre el proceso. Mientras tanto, echa un vistazo a "Mis Movimientos" para seguir el progreso de tu orden. ¡Gracias por confiar en nosotros!',
          MOVEMENTS: 'Ir a Mis movimientos',
          CONTINUE_TRADING: 'Seguir tradeando',
        },
        EMPTY_BTN: 'Ver Oportunidades',
        EMPTY_MSG: 'Todavía no realizaste ningún movimiento',
      },
    },
    SHARED: {
      CARD: {
        INVEST: 'Invertir',
        PERIOD: 'Período',
        TIRA: 'Tira',
        OBJETIVE: 'OBJETIVO',
        PERFORMANCE: 'Rendimiento',
        MIN_INVEST: 'Min inversion',
        CURRENT: 'ACTUAL',
        PROGRESS: 'PROGRESO',
      },
    },
  },
};
